<script>
    import { onMount } from "svelte";
    import { AuthUser } from "../../store.js";
    import Router, { resolveExportUrl } from "../../router.js";
    import wrappedFetch from "../../wrappedFetch.js";
    import Button from "../components/button.svelte";
    import Spinner from "../components/spinner.svelte";
    import Message from "../components/message.svelte";

    export let providerId = 0;

    let title =  providerId == 1 ? "Google" : providerId == 3 ? "Microsoft" : "";
    let isPageLoading = true;
    let multiSyncName = null;
    let isLinkedToMultiSync = false;
    let hasSelectedSetupType = false;

    onMount(async () => {

        await IsSchoolPartOfMultiSync();

        isPageLoading = false;
    });

    const IsSchoolPartOfMultiSync = async () => {
        // console.log($AuthUser.schoolId)
        await wrappedFetch(
            `/api/multiSync/GetMultiSyncNameForSchool?schoolId=${$AuthUser.schoolId}&providerId=${providerId}`, 
            { method: "get" })
            .then (async (resp) => {
                multiSyncName = await resp.text();
            })
            .catch(() => {
                isLinkedToMultiSync = false;
            });
        
        isLinkedToMultiSync = multiSyncName != null && multiSyncName != "";
            
    }

    const onMultiSyncSetup = () => {
        hasSelectedSetupType = true;  
        if (isLinkedToMultiSync == true)
            Router.route(resolveExportUrl(providerId,'/step1'), false);
    }
    $: linkedMessage = `<p>Your school is already part of a ${title} Multi-Sync (${multiSyncName}).` // + 
        // `To set it up as part of Multi-Sync, please click the button below.</p>.` +
        // `If you want to set up as individual school for ${title} then please ask the Multi-Sync admin to remove you from it before proceeding.`;
    
        // TODO - MS: words
    let notLinkedMessage = '<p> Your school is currently not linked to any Multi-Sync. </p>' + 
        '<p>If you want to be a part of an existing Multi-Sync then please ask the admin for the Trust Office/Multi-Sync to add your school to their Multi-Sync and try again once that has been done.</p>' +
        '<p>If you want a new Multi-Sync created, kindly contact Wavenet support through phone <i class="fa fa-phone"> 01689 814777 </i>' + 
        ' or raise an issue <a href="https://www.wavenet.co.uk/contact-us" target="blank"> here</a>. </p>';
</script>

    {#if isPageLoading == true}
        <Spinner />
    {:else}
        <div class="row justify-content-md-center">
            <div class="col-12">
                <div class="row mt-3">
                    {#if isLinkedToMultiSync == false}
                    <div class="col col-4 ">
                        <div class="row" style="display: flex; justify-content:center">
                            <a href="/app/export/{providerId}/step1" target="_self">
                                <img
                                    src="/images/school.jpg"
                                    alt="Individual School"
                                    class="img-responsive"
                                    style=""
                                    width="125px"
                                    height="125px"
                                />
                            </a>
                        </div>
                        <br />
                        <div class="row" style="display: flex; justify-content:center">
                            <a href="/app/export/{providerId}/step1"
                               class="btn btn-primary"
                               target="_self">
                                School Setup
                            </a>
                        </div>
                    </div>
                    {:else}
                        <div class="col-12">
                            <Message bind:message={linkedMessage} />
                        </div>
                    {/if}
                    <div class="col col-4">
                        <div class="row" style="display: flex; justify-content:center">
                            <a href="/app/multisyncPage/{providerId}" target="_self">
                                <img
                                    src="/images/MAT.png"
                                    alt="Multi-Sync"
                                    class="img-responsive"
                                    style=""
                                    width="125px"
                                    height="125px"
                                />
                            </a>
                        </div>
                        <br />
                        <div class="row" style="display: flex; justify-content:center">
                            <Button
                                buttonClass={"btn-primary"}
                                style="min-width:35px; vertical-align: top;"
                                buttonText={"Multi-Sync Setup"}
                                on:click={onMultiSyncSetup}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <br />
        {#if hasSelectedSetupType == true && !isLinkedToMultiSync}
            <Message message={notLinkedMessage} />
        {/if}
    {/if}